import React from 'react';
import './DressCodeSection.css';
import MessageSection from '../messageSection/MessageSection';

function DressCodeSection({ colorProp = { svg: { viewBox: '0 0 64 64', d: "M 32 2 A 30 30 0 1 1 32 62 A 30 30 0 1 1 32 2 Z", border: "true" }, colors: ['#FF6347', '#4682B4', '#32CD32', '#FFD700', '#8A2BE2']}, topMessageProps, bottomMessageProps }) {
  const { svg, colors } = colorProp;
  return (
    <div className="dress-code-section">
      <MessageSection {...topMessageProps}/>

      <div className="paint-brushes-container">
        {colors.map((color, index) => (
          <svg
            key={index}
            className="paint-brush"
            viewBox={svg.viewBox}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d={svg.d}
              fill={color}
              stroke="black"
              strokeWidth={svg.border === "true" ? 1 : 0}
            />
          </svg>
        ))}
      </div>

      <MessageSection {...bottomMessageProps}/>
    </div>
  );
}

export default DressCodeSection;

